import { render, staticRenderFns } from "./jobListDetailMobile.vue?vue&type=template&id=2f754b29&scoped=true"
import script from "./jobListDetailMobile.vue?vue&type=script&lang=js"
export * from "./jobListDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./jobListDetailMobile.vue?vue&type=style&index=0&id=2f754b29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f754b29",
  null
  
)

export default component.exports